import axios from 'axios'
import {Message, MessageBox} from 'element-ui'
import $utils from 'utils.js'

// 检查请求时状态
function checkStatus(response) {
    // 如果http状态码正常，则直接返回数据
    if (response && (response.status === 200 || response.status === 304 || response.status === 400)) {
     /*   let sessionid = $utils.getCookie('sessionid')
        $utils.setCookie('sessionid', sessionid, 120)*/
        return response.data
    } else {
        return {
            status: -404,
            msg: '网络异常'
        }
    }
}
// 错误码对应说明
function checkCode(res) {
    if (res.code !== 0) {
        if(res.code===-2){
          getWechatCode();
          return;
        }
        Message.warning({
            message: res.msg
        })
      }
    return res
}

function getWechatCode() {
  let appId= "wx91943436133755e0";
  let redirectUrl =  encodeURIComponent(window.location.href);
  location.href="https://open.weixin.qq.com/connect/oauth2/authorize?appid="+appId+
    "&redirect_uri="+redirectUrl+"&response_type=code&scope=snsapi_userinfo&state=1#wechat_redirect";
}


export default {
    post(url, params) {
      url  = '/api'+url
        return axios({
            method: 'post',
            url,
            params: params,
            timeout: 10000,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        }).then(
            (response) => {
                return checkStatus(response)
            }
        ).then(
            (res) => {
                return checkCode(res)
            }
        )
    },
    get(url, params) {
      url  = '/api'+url
      return axios({
            method: 'get',
            url,
            params, // get 请求时带的参数
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        }).then(
            (response) => {
                return checkStatus(response)
            }
        ).then(
            (res) => {
                return checkCode(res)
            }
        )
    },
  getWechatCode
}





// WEBPACK FOOTER //
// ./src/util/http.js